module.exports = __webpack_public_path__ + "static/christian-56633ed3f62f39d71f571374a6409e65.jpg";